export const URL = process.env.VUE_APP_URL;
export const apiToken = process.env.VUE_APP_API_TOKEN;

export const IMAGE_URL = process.env.VUE_APP_RESOURCES;
export const imageApiToken = process.env.VUE_APP_RESOURCES_API_TOKEN;
